import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';

// Define the interfaces needed (can be imported from elsewhere later)
interface User {
    id: number;
    name: string;
}

interface Reply {
    id: number;
    content: string;
    createdAt: string;
    author: User;
}

interface ReplyListProps {
    replies: Reply[];
}

const ReplyList: React.FC<ReplyListProps> = ({ replies }) => {

    if (!replies || replies.length === 0) {
        return (
            <Card className="shadow-sm border-0">
                <Card.Body className="text-center text-muted">
                    Be the first to reply!
                </Card.Body>
            </Card>
        );
    }

    return (
        <div className="replies-container">
            {replies.map((reply) => (
                <Card key={reply.id} className="mb-3 shadow-sm border-0" id={`reply-${reply.id}`}>
                    <Card.Body>
                        <Row>
                             {/* Optional: Small avatar/initials column */}
                            {/* 
                            <Col xs="auto" className="pe-2">
                                <div className="avatar rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px', fontSize: '0.9rem' }}>
                                    <span>{reply.author.name ? reply.author.name[0].toUpperCase() : 'U'}</span>
                                </div>
                            </Col> 
                            */}
                            <Col>
                                <div className="d-flex justify-content-between align-items-start mb-2">
                                    <div>
                                        <Link to={`/profile/${reply.author.id}`} className="fw-bold text-decoration-none me-2">{reply.author.name}</Link>
                                        <small className="text-muted">
                                            {formatDistanceToNow(new Date(reply.createdAt), { addSuffix: true })}
                                        </small>
                                    </div>
                                    {/* Placeholder for Reply Actions (Edit/Delete/Report Dropdown) */}
                                    {/* <Button variant="link" size="sm" className="text-muted p-0">...</Button> */}
                                </div>
                                <div className="reply-content" style={{ whiteSpace: 'pre-wrap' }}>
                                    {reply.content}
                                </div>
                                {/* Placeholder for Reply Interactions (Helpful button, etc) */}
                                {/* 
                                <div className="mt-2">
                                    <Button variant="link" size="sm" className="text-muted p-0 me-2">Helpful (0)</Button>
                                </div>
                                */}
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            ))}
        </div>
    );
};

export default ReplyList; 